<template>
  <div>
    <Modal v-model="modal" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center">
        <img src="~assets/img/onlineblock/attentionmulticolor.png" alt />
        <p>要结束对话吗？</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="modal = false">取消</Button>
          <Button class="btn" type="error" @click="endChatConfirm">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { error } from 'util'
export default {
  name: "ModalEndChat",
  props: {
    endChatStatus: {
      type: Boolean,
      required: true
    },
    roomcode: {
      type: String,
      required: true
    },
    mafd: {
      type: Number,
      required: true
    },
    cufd: {
      type: Number,
      required: true
    },
    cuid: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["username", "servid"]),
    modal: {
      get () {
        return this.endChatStatus
      },
      set (val) {
        this.$emit("update:endChatStatus", val)
      }
    }
  },
  methods: {
    ...mapActions(["setmaEndChat", "setservid"]),
    //結束對話
    endChatConfirm () {
      let obj = {
        roomno: this.roomcode,
        maid: Number(this.username.maid),
        servid: Number(this.servid),
        exeType: 1
      }

      this.$axios.inAndOutRm(obj)
        .then(res => {})
        .catch(err => console.error(err))
      this.$axios.refutalk({
        maid: this.username.maid,
        cuid: this.cuid
      })
        .then(res => {
          this.$emit("resetCutklist")
          this.setmaEndChat(true)
        })
        .catch(err => console.error(err))
      this.modal = false
    },
  }
}
</script>